<div class="carousel-container">
  @if (type() === 'image') {
    @if (!isLocalFile()) {
      @if (image(); as image) {
        <img #photoElement [src]="image" [draggable]="false" (loaded)="imageLoaded.set(true)" />
      }
    } @else {
      <img #photoElement [src]="localFileUrl()" [draggable]="false" (loaded)="imageLoaded.set(true)" />
    }

    @if (!imageLoaded()) {
      <sim-spinner class="carousel-container--spinner" />
    }
  }

  @if (hasPrevious()) {
    <sim-icon
      id="slideshow-previous-element"
      (click)="previousElement()"
      class="carousel-container--button-left"
      color="#FFFFFF"
      sizeType="large"
      icon="back"
    />
  }

  @if (hasNext()) {
    <sim-icon
      id="slideshow-next-element"
      (click)="nextElement()"
      class="carousel-container--button-right"
      color="#FFFFFF"
      sizeType="large"
      icon="next"
    />
  }
</div>
